<template>
  <div>
    <v-select
      v-bind="currentProperties()"
      v-model="newValue"
      :loading="field.loading"
      :disabled="field.loading"
    />
  </div>
</template>
<script>

export default {
  name: 'EntitySelect',
  props: [
    'field', 'value'
  ],
  data: function () {
    return { newValue: this.value ? this.value.uuid : null };
  },
  watch: {
    newValue (val) { // Updates v-model on the parent
      this.$emit('input', val ? { uuid: val, wtype: this.field.selectWtype } : null);
    }
  },
  methods: {
    currentProperties: function () {
      const properties = {};

      // General properties
      properties.rules = this.field.rules;
      properties.hint = this.field.helpText;
      properties.label = this.field.label;
      properties.readonly = this.field.readonly;

      // Default v-text-field color
      properties.color = 'info';

      properties.items = this.field.options;
      properties.multiple = this.field.multivalued;

      if (!properties.readonly) {
        properties.clearable = true;
      }

      return properties;
    }
  }
};
</script>
